import * as React from "react";
import type { SVGProps } from "react";
const SvgCheckBox = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    {...props}
  >
    <rect width={18} height={18} fill="#18A09F" rx={0} />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="m13.2 6.5-5.9 5.6-2.5-3 1-.9 1.7 1.9L12.4 5z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCheckBox;
